import { render, staticRenderFns } from "./CChartPieExample.vue?vue&type=template&id=3cbea2d6&"
import script from "./CChartPieExample.vue?vue&type=script&lang=js&"
export * from "./CChartPieExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports